<template>
  <v-card>
    <v-card-title>事業本部別SJL納入場所紐付き
      <v-spacer/>
      <v-btn @click="add">{{$t('app.buttons.add')}}</v-btn>
      <v-btn @click="remove">{{$t('app.buttons.remove')}}</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="value"
      :rows-per-page-items="[10]"
      class="elevation-0"
      hide-actions
      item-key="seq"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>
          <lookup :value="props.item.buId" url="divisions/kv"/>
        </td>
        <td>
          <lookup :value="props.item.sjlWarehouseId" url="warehouses/sjl-kv"/>
        </td>
      </template>
    </v-data-table>
    <add-ref-warehouse-dialog ref="addRefWarehouseDlg"/>
  </v-card>
</template>
<script>
import addRefWarehouseDialog from './AddRefWarehouseDialog'

export default {
  components: { addRefWarehouseDialog },
  props: ['value'],
  data() {
    return {
      headers: [
        { text: '事業本部', value: 'bu' ,sortable:false},
        { text: '紐付きSJL納入場所', value: 'sjlWarehouseId' ,sortable:false}
      ],
      selected: []
    }
  },
  methods: {
    add() {
      this.$refs.addRefWarehouseDlg.popup().then(r => {
        this.$emit('input', [
          ...this.value,
          { ...r, seq: new Date().getTime() }
        ])
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$emit(
            'input',
            this.value.filter(i => this.selected.indexOf(i) === -1)
          )
          this.selected = []
          this.$message('', '削除成功')
        }
      )
    }
  }
}
</script>
